import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "../../HttpClient";

const routes = (apiRoutes as any).BloodLis?.CriticalNoticeCall || {};

/** Tabs configuration - same structure as View Requisition (api/IDResultData/TabsConfiguration) */
export const getTabsConfiguration = () => {
  return HttpClient().get(
    routes.TabsConfiguration || "api/IDResultData/TabsConfiguration"
  );
};

/** Grid data - same payload structure as View Requisition */
export const getAll = (params: {
  tabId: number | null;
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortDirection?: string;
  filters?: any[];
}) => {
  return HttpClient().post(
    routes.GetAll || "api/BloodCriticalNoticeCall/GetAll",
    params
  );
};

/** Expand data when clicking plus icon */
export const getExpandData = (reqOrderId: number | string) => {
  const base =
    routes.GetExpandData || "api/BloodCriticalNoticeCall/GetExpandData";
  const sep = base.includes("?") ? "&" : "?";
  return HttpClient().get(`${base}${sep}reqOrderId=${reqOrderId}`);
};

/** Save expand section (criticalNoticeCallLists) */
export const saveExpand = (payload: CriticalNoticeCallListItem[]) => {
  return HttpClient().post(
    routes.SaveExpand || "api/BloodCriticalNoticeCall/SaveExpand",
    payload
  );
};

/** Mark critical notice call complete (moves order to closed); same body as saveExpand */
export const completeCriticalNoticeCall = (
  payload: CriticalNoticeCallListItem[]
) => {
  return HttpClient().post(
    routes.Complete || "api/BloodCriticalNoticeCall/CompleteCriticalNotice",
    payload
  );
};

export interface CriticalNoticeCallListItem {
  requisitionOrderId: number;
  criticalNoticeCallId: number;
  panelId: number;
  panelName: string;
  units: string;
  flag: string;
  resultValue: string;
  testId: number;
  testName: string;
  dateAndTime: string;
  notifyBy: string;
  notifyTo: string;
  readBack: string;
}

/**
 * Get list of active critical notice calls.
 * Change endpoint in Routes.json -> BloodLis.CriticalNoticeCall.GetActiveCalls
 */
export const GetActiveCalls = (params: {
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortDirection?: string;
  queryModel?: Record<string, unknown>;
}) => {
  return HttpClient().post(
    routes.GetActiveCalls || "api/BloodLIS/CriticalNoticeCall/GetActiveCalls",
    params
  );
};

/**
 * Get list of closed critical notice calls.
 * Change endpoint in Routes.json -> BloodLis.CriticalNoticeCall.GetClosedCalls
 */
export const GetClosedCalls = (params: {
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortDirection?: string;
  queryModel?: Record<string, unknown>;
}) => {
  return HttpClient().post(
    routes.GetClosedCalls || "api/BloodLIS/CriticalNoticeCall/GetClosedCalls",
    params
  );
};

/**
 * Get critical contact information for a call/accession.
 * Change endpoint in Routes.json -> BloodLis.CriticalNoticeCall.GetCriticalContactInfo
 */
export const GetCriticalContactInfo = (accessionId: string | number) => {
  const base =
    routes.GetCriticalContactInfo ||
    "api/BloodLIS/CriticalNoticeCall/GetCriticalContactInfo";
  return HttpClient().get(`${base}?accessionId=${accessionId}`);
};

/**
 * Get patient test results for a call/accession.
 * Change endpoint in Routes.json -> BloodLis.CriticalNoticeCall.GetPatientTestResults
 */
export const GetPatientTestResults = (accessionId: string | number) => {
  const base =
    routes.GetPatientTestResults ||
    "api/BloodLIS/CriticalNoticeCall/GetPatientTestResults";
  return HttpClient().get(`${base}?accessionId=${accessionId}`);
};

/**
 * Save result (critical contact + patient test results).
 * Change endpoint in Routes.json -> BloodLis.CriticalNoticeCall.SaveResult
 */
export const SaveResult = (payload: {
  accessionId: string | number;
  contactName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  patientTestResults?: Array<{
    testId?: number;
    resultValue?: string;
    dateTime?: string;
    responsibleInc?: string;
  }>;
}) => {
  return HttpClient().post(
    routes.SaveResult || "api/BloodLIS/CriticalNoticeCall/SaveResult",
    payload
  );
};
